import { render } from "./Warn.vue?vue&type=template&id=25be1f6c"
import script from "./Warn.vue?vue&type=script&lang=js"
export * from "./Warn.vue?vue&type=script&lang=js"

import "./Warn.vue?vue&type=style&index=0&id=25be1f6c&lang=scss"
script.render = render

export default script